import { render, staticRenderFns } from "./WarehouseCard.vue?vue&type=template&id=9f4de88a"
import script from "./WarehouseCard.vue?vue&type=script&lang=js"
export * from "./WarehouseCard.vue?vue&type=script&lang=js"
import style0 from "./WarehouseCard.vue?vue&type=style&index=0&id=9f4de88a&prod&lang=scss"
import style1 from "./WarehouseCard.vue?vue&type=style&index=1&id=9f4de88a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports